import { Extent } from "ol/extent";
import { getTrip_cachedForm, mi_to_meter } from "../util/general_util";
import { Campground_Data, copilot_err_resp, copilot_success_resp, genieTripReq_params, genieTripReq_stop, POI_Data, Trip_Cluster_v2, Trip_cookieFormat, Trip_cookieFormat_v2, Trip_v2 } from "../util/tripPlanner_types";
import { Trip_ReqFields_stopByStop } from "../util/type_defs";
import { send_getAPItoken } from "../util/search_api";

export const avoidArea = async(query:string):Promise<Trip_v2> => {
    return new Promise<Trip_v2>((resolve,reject) => {
        $.ajax({
            type: "get",
            url: `/avoidArea?q=${query}`,
            contentType: "x-www-form-urlencoded",
            dataType: "json",
            success: (data) => {resolve(data)},
            error: (xhr,errStr,exc)=>{
				reject(new Error(xhr.responseText));
			}
        })
    });
}
export const get_favoritedCamps = async (campIDs:number[]|null):Promise<number[]> => {
    let url:string = "/favoritedCamps";
    if (campIDs) {
        url += `?ids=${JSON.stringify(campIDs)}`
    }
    return new Promise<number[]>((resolve,reject) => {
        $.ajax({
            url: url,
            type:"get",
            dataType: "json",
            success: (data) => {resolve(data)},
            error: (xhr,errStr,exc)=>{
				reject(new Error(xhr.responseText));
			}
        })
    });
};


export const addPOI_asStop = async (trip:Trip_v2, poiID:number,  closestStopsIndices:Array<{legIndex:number,stopIndex:number}>):Promise<Trip_v2> => {
    return new Promise<Trip_v2>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/addPoiAsStop",
            data: JSON.stringify({
                poiID: poiID,
                closestStopsIndices:closestStopsIndices,
                trip: getTrip_cachedForm(trip)
            }),
            contentType: "application/json",
            dataType: "json",
            success: (data) => {resolve(data)},
            error: (xhr,errStr,exc)=>{
				reject(new Error(xhr.responseText));
			}
        })
    });
};

export const get_poiPinPopup = async (poi:any):Promise<string> => {
    return new Promise<string>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/getPoiPinPopup",
            contentType: "application/json",
            data: JSON.stringify(poi),
            dataType: "html",
            success: (data)=>{resolve(data)},
            error: (xhr,errStr,exc)=>{
				reject(new Error(xhr.responseText));
			}
        });
    });
};

export const get_poiOnRoutePinPopup = async (poi:any):Promise<string> => {
    return new Promise<string>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/getPoiOnRoutePinPopup",
            contentType: "application/json",
            data: JSON.stringify(poi),
            dataType: "html",
            success: (data) => {resolve(data)},
            error: (xhr,errStr,exc)=>{
				reject(new Error(xhr.responseText));
			}
        })
    });
};

export const get_stop_img = (q:string):Promise<string> => {
    return new Promise<string>((resolve,reject) => {
        $.ajax({
            type: "get",
            url: `/stopImg?q=${q}`,
            contentType: "x-www-form-urlencoded",
            dataType: "text",
            success: (data) => {resolve(data)},
            error: (xhr,errStr,exc)=>{
				reject(new Error(xhr.responseText));
			}
        })
    });
};

export const update_interests = (interests:string):Promise<void> => {
    return new Promise<void>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/setUserInterests",
            data: JSON.stringify({interests:interests}),
            contentType: "application/json",
            success: () => {resolve},
            error: (xhr,errStr,exc)=>{
				reject(new Error(xhr.responseText));
			}
        })
    });
};

export const addStop_noLoc = (stop_name:string):Promise<Trip_v2> => {
	return new Promise<Trip_v2>((resolve,reject) => {
		$.ajax({
			type: "post",
			url: "/addStop_noLoc",
			data: JSON.stringify({stop_name:stop_name}),
			contentType: "application/json",
			dataType: "json",
			success: (data) => {
				resolve(data);
			},
			error: (xhr,errStr,exc)=>{
				reject(new Error(xhr.responseText));
			}
		});
	});
};

async function allInOneTrip_streamResp(apiToken:string, query:string) {
	return new Promise<string>((resolve,reject) => {
		const source = new EventSource(`/ai_get_trip?token=${apiToken}&query=${query}`);
		try {

			let buffer:string = "";
			let responseFull:string = "";
			const myRegex:RegExp = /{(?:(?!{"title":).)*?}/g;
			source.onmessage = function(event) {
				$("#iterResultsDisp").removeClass("d-none");
				responseFull += event.data;

				let stops_strs:Array<string>|null = responseFull.match(myRegex);
				let html:string = "";
				if (stops_strs != null) {

					for (let i:number = 0; i < stops_strs.length; i++) {
						let stop:{title:string,itinerary?:string} = JSON.parse(stops_strs[i]);

                        html += "<div class='d-flex flex-column flex-fill'>";
                        html += "   <div class='tripOverviewStop card flex-fill shadow'>"

                        html += "       <div class='d-flex rounded-top border border-userStop'>";
                        html += `           <div class="slanted-border rounded-top rounded-end-0 ps-2 bg-userStop text-white fw-bold d-flex align-items-center text-nowrap flex-shrink-1" style="min-width:0;">STOP ${i+1}</div>`
                        html += "       </div>"

                        html += "       <div class='card-body p-2 pb-0'>";
                        html += `           <div class='stopTitle mb-2 text-truncate mx-2'>${stop.title}</div>`;
                        html += "       </div>";
                        if (stop.itinerary != undefined) {
                        html += "       <div class='card-footer p-0 d-flex justify-content-start ms-2'>";
                        html += "           <a class='nav-link active p-0 d-flex d-center'>Activities</a>";
                        html += "       </div>"
                        };
                        html += "   </div>";
                        if (stop.itinerary != undefined) {
                        html += "   <div class='card p-2'>";
                        html += `       <div>${stop.itinerary}</div>`;
                        html += "   </div>";
                        };
                        html += "</div>";

					};
				}
				$("#iterResultsStopsDisp").html(html)
			};
			source.addEventListener("end", function(e) {
				source.close();
				resolve(responseFull);
			});
			source.onerror = (event:Event) => {
				source.close();
				reject(event)
			};
		} catch (error:any) {
			source.close();
			reject(error);
		}
	});
};

export const send_tripPlanAllInOneSearch = (stopData:Array<any>,searchQuery:string):Promise<Trip_v2> => {
    return new Promise<Trip_v2>((resolve,reject) => {
        $.ajax({
            type: "post",
            url:"/tripPlanner_autoGenTrip",
            data: JSON.stringify({stopData: stopData,searchQuery:searchQuery}),
            contentType: 'application/json',
            dataType:'json',
            success: (data) => {
                if (data.directions) resolve(data);
                else reject(new Error("Couldnt get directions"))
            },
            error: (xhr, errStr, exc) => {reject(new Error(errStr));}
        })
    });
};

export const send_AIsearchAllInOne =  async (apiToken:string, query:string):Promise<any[]> => {
    return new Promise<any[]>((resolve,reject) => {
        if (query.trim().length > 0) {
            allInOneTrip_streamResp(apiToken, query).then(response => {
                resolve(JSON.parse(response));
            }).catch(e => {
                reject(new Error(e.toString()));
            });
        } else {
            reject(new Error("query is empty"))
        };
    });
};

export const send_copilot_req = async (userInput:string, trip:Trip_v2):Promise<copilot_success_resp|copilot_err_resp> => {
	const apiToken:string = await send_getAPItoken();

	let tripStops:{name:string,identifier:string}[] = [];
	if (trip != undefined && trip != null && trip.legs != null) {
	for (let i:number = 0; i < trip.legs.length; i++) {
			for (let j:number = 0; j < trip.legs[i].clusters.length; j++) {
				tripStops.push({
					name: trip.legs[i].clusters[j].clusterTitle,
					identifier: trip.legs[i].clusters[j].stopID
				});
			};
		};
	};

    return new Promise<copilot_success_resp|copilot_err_resp>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/copilot",
            data: JSON.stringify({
                userInput: userInput,
                tripStops:tripStops,
                history: window.copilotHistory
            }),
            headers: {
                "Authorization": `Bearer ${apiToken}`
            },
            contentType: "application/json",
            dataType: "json",
            success: (data) => {resolve(data)},
            error: (xhr, errStr, exc) => {reject(new Error(errStr));}
        });
    });
};

export const getPOIs_onRoute = (geometry:Array<Array<number>>,bounds:Extent, distToLine_m:number, typeIDs:number[], openRoads:Boolean=false):Promise<POI_Data[]> => {
    return new Promise<POI_Data[]>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/getPOIs_onRoute",
            data: JSON.stringify({
                line: geometry,
                bounds:bounds,
                typeIDs: typeIDs,
                dist: distToLine_m,
                openRoads: openRoads
            }),
            contentType: "application/json",
            dataType: "json",
            success: (data) => {resolve(data)},
            error: (xhr, errStr, exc) => {
                if (xhr.status == 403) reject(new Error("invalid-access"))
                reject(new Error(errStr));
            }
        });
    });
};

export const getOpenRoads_onRoute = (geometry:Array<Array<number>>,bounds:Extent, distToLine_m:number):Promise<POI_Data[]> => {
    return new Promise<POI_Data[]>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/getOpenRoads_onRoute",
            data: JSON.stringify({
                line: geometry,
                bounds:bounds,
                dist: distToLine_m
            }),
            contentType: "application/json",
            dataType: "json",
            success: (data) => {resolve(data)},
            error: (xhr, errStr, exc) => {
                if (xhr.status == 403) reject(new Error("invalid-access"))
                reject(new Error(errStr));
            }
        });
    });
};

export const getPoiOnRouteControl = ():Promise<string> => {
    return new Promise<string>((resolve,reject) => {
        $.ajax({
            type: "get",
            url: "/getPoiOnRouteControl",
            dataType: "html",
            success: (data) => {resolve(data)},
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        });
    });
};

export const updateStopRadius = (legIndex:number,stopIndex:number,radius:number):Promise<void> => {
    return new Promise<void>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/updateStopRadius",
            data: JSON.stringify({
                legIndex: legIndex,
                stopIndex: stopIndex,
                radius: radius
            }),
            contentType: "application/json"
        });
    });
};

export const get_cluster = (coords:{latitude:number,longitude:number},radius:number):Promise<Campground_Data[]> => {
    return new Promise<Campground_Data[]>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/tripPlanner_getCluster",
            data:JSON.stringify({coords:coords,radius:radius}),
            contentType: "application/json",
		    dataType: "json",
            success: (data) => {resolve(data)},
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        });
    });
};

export const getGenieTripFromID = async (tripID:string):Promise<Trip_v2> => {
    return new Promise<Trip_v2>((resolve,reject) => {
        $.ajax({
            type: "get",
            url: `/loadGenieTrip?id=${tripID}`,
            contentType: "application/x-www-form-urlencoded",
            dataType: "json",
            success: (data) => {resolve(data)},
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        });
    });
};

export const get_genieTrip = (tripID: string, stops: Array<genieTripReq_stop>, driveTime: number, driveDist: number, routeWidth: number, avoidHighways: number, routeStart_query: string | null, routeEnd_query: string | null, routeStart_query_type: string | null, routeStart_query_val: string | null, routeEnd_query_type: string | null, routeEnd_query_val: string | null, isFRVT:string|null):Promise<Trip_v2> => {
    const params: genieTripReq_params = {
		tripID: tripID,
		stops: stops,
		driveTime: driveTime,
		driveDist: driveDist,
		routeWidth: routeWidth,
		avoidHighways: avoidHighways,
        isFRVT:isFRVT
	};

	if (routeStart_query != null) {
		params.routeStart_query = routeStart_query;
		if (routeStart_query_type != null && routeStart_query_val != null) {
			params.routeStart_query_type = routeStart_query_type;
			params.routeStart_query_val = routeStart_query_val;
		};
	};

	if (routeEnd_query != null) {
		params.routeEnd_query = routeEnd_query;
		if (routeEnd_query_type != null && routeEnd_query_val != null) {
			params.routeEnd_query_type = routeEnd_query_type;
			params.routeEnd_query_val = routeEnd_query_val;
		};
	};

    return new Promise<Trip_v2>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/tripPlanner_getGenieTrip",
            data: JSON.stringify(params),
            contentType: "application/json",
            dataType: "json",
            success: (data) => {resolve(data)},
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        });
    });
};

export const getPublishedTrip = (tripID:string):Promise<Trip_v2> => {
    return new Promise<Trip_v2>((resolve,reject) => {
        $.ajax({
            type: "get",
            url: `/publishedTrip?id=${tripID}`,
            contentType: "application/x-www-form-urlencoded",
            dataType: "json",
            success: (data) => { resolve(data)},
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        })
    });
};

export const getShareTripBtn = ():Promise<string> => {
    return new Promise<string>((resolve,reject) => {
        $.ajax({
            type: "get",
            url: "/shareTripBtn",
            dataType: "html",
            success: (data) => {resolve(data)},
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        })
    });
};

export const getSaveTripBtn = ():Promise<string> => {
    return new Promise<string>((resolve,reject) => {
        $.ajax({
            type: "get",
            url: "/saveTripBtn",
            dataType: "html",
            success: (data) => {resolve(data)},
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        })
    });
};

export const getTripFromID = async (tripID:string):Promise<Trip_v2> => {
    return new Promise<Trip_v2>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/getUserTrip",
            data: JSON.stringify({tripID:tripID}),
            contentType: "application/json",
            dataType: "json",
            success: (data) => {resolve(data)},
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        });
    });
};

export const saveTrip = (trip:Trip_v2, tripName:string, fromViewOnly:boolean) => {
    if (!tripName) tripName = "unnamed";
    trip.name = tripName
    return new Promise<string>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/saveTrip",
            data: JSON.stringify({
                trip: getTrip_cachedForm(trip),
                fromViewOnly: fromViewOnly
            }),
            contentType: "application/json",
		    dataType: "json",
            success: (data) => {
                if (data.status == "success") {
                    resolve(data.tripID);
                } else {
                    reject(new Error(data.tripID))
                };
            },
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        });
    });
};

export const remove_poi = (stopID:string, poiID:number):Promise<Trip_v2> => {
    return new Promise<Trip_v2>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/removePOI",
            data: JSON.stringify({
                stopID:stopID,
                poiID:poiID
            }),
            contentType: "application/json",
            dataType: "json",
            success: (trip) => {resolve(trip)},
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        });
    });
};

export const add_poi_to_stop = (stopID:string, poiID:number):Promise<Trip_v2> => {
    return new Promise<Trip_v2>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/addPOI",
            data: JSON.stringify({
                stopID:stopID,
                poiID:poiID
            }),
            contentType: "application/json",
            dataType: "json",
            success: (trip) => {resolve(trip)},
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        });
    });
};

export const updateTripState = (trip:Trip_v2):Promise<void> => {
    return new Promise<void>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/updateTripState",
            data: JSON.stringify(getTrip_cachedForm(trip)),
            contentType: "application/json",
            success: () => {resolve()},
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        });
    });
};

export const addStop = (trip:Trip_v2, legIndex:number, query:string, autofill_type:string|null, autofill_val:string|null):Promise<Trip_v2> => {
    let errMsg:string;
    return new Promise<Trip_v2>((resolve, reject) => {
        $.ajax({
            type: "post",
            url: "/tripPlanner_addLeg",
            data: JSON.stringify({
                trip: getTrip_cachedForm(trip),
                legIndex: legIndex,
                searchQuery: query,
                autofill_type: autofill_type,
                autofill_val: autofill_val,
            }),
            contentType: "application/json",
            dataType: "json",
            success: (data)=>{
                resolve(data);
            },
            error: (xhr, errStr, exc) => {
                if (xhr.status == 403 && xhr.responseText.toLowerCase().includes("maximum stops")) {
                    reject(new Error("max-stops"));
                } else {
                    errMsg = xhr.responseJSON.errMsg
                    reject(new Error(errMsg));
                };
            }
        });
    });
};

export const setStopDates = (stop:Trip_Cluster_v2,legIndex:number,stopIndex:number):Promise<void> => {
    return new Promise<void>((resolve,reject) => {
        $.ajax({
            "type": "post",
            "url": "/updateStopDates",
            "data": JSON.stringify({
                legIndex: legIndex,
                stopIndex: stopIndex,
                s_date: stop.s_date,
                numNights: stop.numNights
            }),
            contentType: "application/json",
            success: (data) => {resolve()},
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        });
    });
};

export const setStayDates = (stay:Campground_Data, legIndex:number, stopIndex:number):Promise<void> => {
    return new Promise<void>((resolve,reject) => {
        $.ajax({
            "type": "post",
            "url": "/updateStayDates",
            "data": JSON.stringify({
                legIndex: legIndex,
                stopIndex: stopIndex,
                campID: stay.camp.campID,
                s_date: stay.s_date,
                numNights: stay.numNights
            }),
            contentType: "application/json",
            success: (data) => {resolve()},
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        });
    });
};

export const lock_stop = (trip:Trip_v2, legIndex:number, stopIndex:number, stopID:string):Promise<Trip_v2> => {
    return new Promise<Trip_v2>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/lockStop",
            data: JSON.stringify({
                trip: getTrip_cachedForm(trip),
                legIndex: legIndex,
                stopIndex: stopIndex,
                stopID: stopID
            }),
            contentType: "application/json",
            dataType: "json",
            success: (data) => { resolve(data)},
            error: (xhr, errStr, exc) => {
                if (xhr.status == 403 && xhr.responseText.toLowerCase().includes("maximum stops")) {
                    reject(new Error("max-stops"));
                } else {
                    reject(new Error(errStr));
                };
            }
        });
    });
};

export const remove_stop = (trip:Trip_v2, legIndex:number,stopIndex:number, stopID:string):Promise<Trip_v2> => {
    return new Promise<Trip_v2>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/removeStop",
            data: JSON.stringify({
                trip: getTrip_cachedForm(trip),
                legIndex: legIndex,
                stopIndex: stopIndex,
                stopID: stopID
            }),
            contentType: "application/json",
            dataType: "json",
            success: (data) => {
                if (data.trip != null) resolve(data.trip);
                else reject("tripDeleted")
            },
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        })
    });
};

export const fetch_genieMatches = (campIDs:number[]):Promise<{campID:number,genieMatch:number}[]> => {
    return new Promise<{campID:number,genieMatch:number}[]>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/genieMatch",
            data: JSON.stringify(campIDs),
            "contentType": "application/json",
            "dataType": "json",
            success: (data) => {resolve(data)},
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        });
    });
};

export const reorder_stops = (trip:Trip_v2, order:Array<{legIndex:number,stopIndex:number}>):Promise<Trip_v2> => {
    return new Promise<Trip_v2>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/reorderStops",
            data: JSON.stringify({
                trip: getTrip_cachedForm(trip),
                order: order
            }),
            contentType: "application/json",
            dataType: "json",
            success: (data) => {resolve(data);},
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        });
    });
};

export const send_removeStay = (legIndex:number, stopIndex:number, campID:number):Promise<void> => {
    return new Promise<void>((resolve,reject) => {
        $.ajax({
            "type": "post",
            "url": "/removeStayFromStop",
            "data": JSON.stringify({
                legIndex: legIndex,
                stopIndex: stopIndex,
                campID: campID
            }),
            contentType: "application/json",
            success: () => {resolve()},
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        });
    })
};

export const get_campgroundPinPopup_mobile = (campData:any,is_userStop:boolean,dist_unit:string):Promise<string> => {
    return new Promise<string>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/getCampgroundPinPopup_mobile",
            data: JSON.stringify({campData:campData,is_userStop:is_userStop,dist_unit:dist_unit}),
            contentType: "application/json",
            dataType: "html",
            success: (data) => {resolve(data)},
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        });
    });
};

export const get_campgroundPinPopup = (campData:any,is_userStop:boolean,dist_unit:string):Promise<string> => {
    return new Promise<string>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/getCampgroundPinPopup",
            data: JSON.stringify({campData:campData,is_userStop:is_userStop,dist_unit:dist_unit}),
            contentType: "application/json",
            dataType: "html",
            success: (data) => {resolve(data)},
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        });
    });
};

export const send_updateTripWishes = (wishes:Array<{legIndex:number,stopIndex:number,wishes:string[]}>):Promise<void> => {
    return new Promise<void>((resolve,reject) => {
        $.ajax({
             type: "post",
             url: "/updateTripWishes",
             data: JSON.stringify(wishes),
             contentType: "application/json",
             success: () => {resolve();},
             error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
             }
         });
     });
};

export const get_wishesToken = ():Promise<string> => {
    return new Promise<string>((resolve,reject) => {
        $.ajax({
            type: "get",
            url: "/AG_wishes_token",
            dataType: "text",
            success: (data) => {resolve(data);},
            error: (xhr, errStr, exc)=>{reject(new Error(errStr))}
        });
    });
};


export const recalc = (trip:Trip_v2, leg_settings:Array<{legs:number[],dist:number}>):Promise<Trip_v2> => {
    return new Promise<Trip_v2>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/recalcTrip",
            data: JSON.stringify({
                trip: getTrip_cachedForm(trip),
                leg_settings: leg_settings
            }),
            contentType: "application/json",
            dataType: "json",
            success: (data) => {resolve(data)},
            error: (xhr, errStr, exc)=>{reject(new Error(errStr))}
        })
    });
};

export const get_pois_for_stop = (stop:Trip_Cluster_v2, stopID:string, typeIDs:number[], radius_mi:number):Promise<POI_Data[]> => {
    // const radius:number = stop.radius != undefined? mi_to_meter(stop.radius): 64373.8;//64373.8 is 40mi in m
    const latitude:number = stop.coords.latitude;
    const longitude:number = stop.coords.longitude;

    const radius = mi_to_meter(radius_mi);

    return new Promise<POI_Data[]>((resolve,reject) => {
        $.ajax({
            type: "get",
            url: `/getPOIs?types=${typeIDs}&r=${radius}&lat=${latitude}&lng=${longitude}&id=${stopID}`,
            contentType: "application/x-www-form-urlencoded",
            dataType: "json",
            success: (data) => {resolve(data)},
            error: (xhr, errStr, exc) => {
                if (xhr.status == 403) reject(new Error("invalid-access"))
                reject(new Error(errStr));
            }
        })
    });
}

export const send_updateTripNotes = (notes:Array<{legIndex:number,stopIndex:number,notes:string}>):Promise<void> => {
    return new Promise<void>((resolve,reject) => {
       $.ajax({
            type: "post",
            url: "/updateTripNotes",
            data: JSON.stringify(notes),
            contentType: "application/json",
            success: () => {resolve();},
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        });
    });
};

export const send_addCustomStayToStop = async (legIndex:number, stopIndex:number, campID:number, s_date:Date|null, numNights:number|null, customName:string) => {
    $.ajax({
        type: "post",
        url: "/addStayToStop",
        data: JSON.stringify({
			legIndex: legIndex,
			stopIndex: stopIndex,
			campID: campID,
			s_date: s_date,
			numNights: numNights,
			isCustom: true,
			customName: customName
		}),
		contentType: "application/json"
    })
};

export const send_addStayToStop = async (legIndex:number, stopIndex:number, campID:number, s_date:Date|null, numNights:number|null) => {
    await $.ajax({
		"type": "post",
		"url": "/addStayToStop",
		"data": JSON.stringify({
			legIndex: legIndex,
			stopIndex: stopIndex,
			campID: campID,
			s_date: s_date,
			numNights: numNights,
			isCustom: false
		}),
		contentType: "application/json"
	});
};

export const getTripHTML = async (trip:Trip_v2):Promise<string> => {
    return new Promise<string>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/tripHTML",
            data: JSON.stringify(getTrip_cachedForm(trip)),
            contentType: "application/json",
            dataType: "html",
            success: (data) => {resolve(data)},
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        })
    });
};

export const getTripDirections = async (trip:Trip_v2):Promise<any> => {
    return new Promise<any>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/tripDirections",
            data: JSON.stringify(getTrip_cachedForm(trip)),
            contentType: "application/json",
            dataType: "json",
            success: (data) => {resolve(data)},
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        });
    });
};

export const send_getCurTrip = async (tripCookie:Trip_cookieFormat|string):Promise<Trip_v2> => {
    let data:string;
    if (tripCookie instanceof Object) {
		/* this is to handle old cookies
		 * new trips should have string id for cookie
		 */
		data = JSON.stringify(tripCookie);
	} else {
		data = JSON.stringify({"cachedTripID": tripCookie});
	};

    return new Promise<Trip_v2>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/tripPlanner_curTrip",
            data: data,
            contentType: "application/json",
            dataType: "json",
            success: (data) => {
                if (data.response=="success") {
                    resolve(data.trip);
                } else {
                    reject(data.response);
                };
            },
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        });
    });
};

export const stopByStop_search = async (params:Trip_ReqFields_stopByStop):Promise<Trip_v2> => {
    let errMsg:string;
    return new Promise<Trip_v2>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/tripPlanner",
            data: JSON.stringify(params),
            contentType: 'application/json',
            dataType:'json',
            success: (data) => {
               resolve(data);
            },
            error: (xhr, errStr, exc)=>{
                errMsg=xhr.responseJSON.errMsg;
                reject(new Error(errMsg));
            }
        })
    });
};

export const get_tripNotes = async ():Promise<any> => {
	return new Promise<any>((resolve, reject) => {
		$.ajax({
			type: "get",
			url: "/tripNotes",
			dataType: "json",
			success: (data) => {resolve(data)},
			error: (xhr, errStr, exc) => {reject(new Error(errStr))}
		});
	});
};

export const deleteCachedTrip = async (tripID:string):Promise<void> => {
    return new Promise<void>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/deleteCachedTrip",
            data: JSON.stringify({tripID:tripID}),
            contentType: "application/json",
            success: (data) => {resolve()},
            error: (xhr, errStr, exc) => {reject(new Error(errStr))}
        });
    });
};

export const download_trip_pdf = async(trip:Trip_cookieFormat_v2, trip_dist:number, trip_duration:number, trip_dists:Array<number>, trip_durations:Array<number>):Promise<void> => {
    const pdf_name:string = (trip.n != null)? `AdventureGenieTrip-${trip.n}.pdf`: "AdventureGenieTrip-unnamed.pdf";
    return new Promise<void>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/printTrip",
            data: JSON.stringify({
                trip:trip,
                trip_dist:trip_dist,
                trip_duration:trip_duration,
                trip_dists:trip_dists,
                trip_durations:trip_durations,
                tz: Intl.DateTimeFormat().resolvedOptions().timeZone
            }),
            contentType: "application/json",
            xhrFields: {
                responseType: "blob"
              },
            success: (data) => {
                let url:string;
                try {
                    url = URL.createObjectURL(data);
                    window.open(url,'_blank');
                } catch {
                    url = URL.createObjectURL(data);
                    let link = document.createElement("a");
                    link.href = url;
                    link.download = pdf_name;
                    $("#exportTripSidebar").append(link);
                    link.click();
                };

                // $(
                //     [
                //         '<div exportlink="exportlink", onclick="this.remove()" class="d-flex gap-1">',
                //         '<p>If pdf does not automatically open click</p>',
                //         `<a href="${url}" target="_blank">here</a>`,
                //         '</div>'
                //     ].join("\n")
                // ).insertBefore("#printTrip");
                resolve();
            },
            error: (xhr, errStr, exc)=>{
                reject(new Error(errStr));
            }
        })
    });
};

export const download_trip_gpx = async(trip:Trip_cookieFormat_v2):Promise<void> => {
    const gpx_name:string = (trip.n != null)? `AdventureGenieTrip-${trip.n}.gpx`: "AdventureGenieTrip-unnamed.gpx";
    return new Promise<void>((resolve,reject) => {
        fetch("/get_trip_export_gpx", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(trip)
        })
        .then(response => response.blob())
        .then(data => {
            let url = URL.createObjectURL(data);
            let link = document.createElement("a");
            link.href = url;
            link.download = gpx_name;
            $("#exportTripSidebar").append(link);
            link.click();
            resolve();
        })
        .catch(error => {
            console.error("Error:", error);
            reject(new Error(error));
        });
    });
};

export const download_trip_xlsx = async (trip:Trip_cookieFormat_v2,dist:number):Promise<void> => {
    const xlsx_name:string = (trip.n != null)? `AdventureGenieTrip-${trip.n}.xlsx`: "AdventureGenieTrip-unnamed.xlsx";
    return new Promise<void>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/get_trip_export_xlsx",
            data: JSON.stringify({
                trip:trip,
                dist:dist,
                tz: Intl.DateTimeFormat().resolvedOptions().timeZone
            }),
            contentType: "application/json",
            xhrFields: {
                responseType: "blob"
            },
            success: (data) => {
                let url = URL.createObjectURL(data);
                let link = document.createElement("a");
                link.href = url;
                link.download = xlsx_name;
                $("#exportTripSidebar").append(link);
                link.click();
                resolve();
            },
            error: (xhr, errStr, exc)=>{
                reject(new Error(errStr));
            }
        });
    });
};

export const getCityAutofill = async (query:string):Promise<string> => {
    return new Promise<string>((resolve,reject) => {
        $.ajax({
            type: "get",
            url: `/city_autofill?q=${query}`,
            dataType: "html",
            success: (data) => {resolve(data)},
            error: (xhr, errStr, exc) => {
                reject(new Error(errStr));
            }
        });
    });
};